<script setup lang="ts">
const route = useRoute()
const hasHero = computed(() => Boolean(route.meta.hasHero))

useScrollReveal()

watch(
  hasHero,
  (v) => {
    if (!import.meta.client) return
    document.body.classList.toggle('has-hero', v)
  },
  { immediate: true },
)

onUnmounted(() => {
  if (import.meta.client) document.body.classList.remove('has-hero')
})
</script>

<template>
  <div>
    <AppHeader />
    <div v-if="!hasHero" class="page-offset" aria-hidden="true" />
    <slot />
    <AppFooter />
  </div>
</template>

<style scoped>
.page-offset {
  height: 140px;
}

@media (max-width: 760px) {
  .page-offset {
    height: 72px;
  }
}
</style>
